import script from "./HelpItemQuestionDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpItemQuestionDetail.vue?vue&type=script&setup=true&lang=js"

import "./HelpItemQuestionDetail.vue?vue&type=style&index=0&id=86278638&lang=less&scoped=true"
import "./HelpItemQuestionDetail.vue?vue&type=style&index=1&id=86278638&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86278638"]])

export default __exports__